// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"ChartWrapper_chartWrapper__jkyrQ","controlsContainer":"ChartWrapper_controlsContainer__h86oM","canvasContainer":"ChartWrapper_canvasContainer__Vud2J"};